import React, { useState } from "react";
import { connect } from "react-redux";
import BinTransferScanner from "../../BinTransferScanner";
import { PSRemainingBoxWrapper, ToWrapper } from "./PSScan.styled";
import { Divider, Tag } from "antd";
import { BIN_SCAN_TYPES } from "../../../constants";

const getDividerStyles = (addMargin) => {
  if (addMargin) {
    return { marginBottom: "2em" };
  }
  return {};
};
const PSContainerScan = ({ data, submitCall, history }) => {
  const [isErrScan, setIsErrScan] = useState(null);

  const binSubmitCall = async (result, type) => {
    setIsErrScan(null);
    const currScanSubmit = new Promise((resolve) => {
      submitCall(result, type === BIN_SCAN_TYPES.SOURCE_SCAN, resolve);
    });
    await Promise.allSettled([currScanSubmit]).then((results) => {
      if (results[0]?.status !== "fulfilled" || !results[0]?.value) {
        setIsErrScan(type);
      } else {
        setIsErrScan(null);
      }
    });
  };

  return (
    <>
      {data?.toId && (
        <Divider style={getDividerStyles(!data?.remaningBoxNoList?.length)}>
          <ToWrapper>
            <div className="toLabel">To Number :</div>
            <div className="toValue">{data?.toId}</div>
          </ToWrapper>
        </Divider>
      )}
      {data?.remaningBoxNoList?.length ? (
        <>
          <Divider>Remaining Box List </Divider>
          <PSRemainingBoxWrapper>
            {data?.remaningBoxNoList?.map((k, p) => (
              <Tag key={p}>{k}</Tag>
            ))}
          </PSRemainingBoxWrapper>
        </>
      ) : null}

      <BinTransferScanner
        actionOnFirstScan={(result) =>
          binSubmitCall(result, BIN_SCAN_TYPES.SOURCE_SCAN)
        }
        onSubmit={(currBarcode, result) =>
          binSubmitCall(result, BIN_SCAN_TYPES.DESTINATION_SCAN)
        }
        history={history}
        validateScan2={data?.destinationBoxNo}
        validateScan1={data?.sourceBoxNo}
        clearScanner={isErrScan}
        allowSame
      />
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PSContainerScan);
